import React from "react";
import { RouteComponentProps } from 'react-router-dom';
import { connect } from "react-redux";
import Header from "../components/Header";
import { IQuoteStepState, IQuoteStepComponentProps } from "../components/interfaces";
import { IAppState } from "../state/interfaces";
import { IVehicle, IViolationList, ICoverageConfig, IQuoteApiClient, ILOBApiClient, IPaths } from "../classes/Domain";
import QuoteActions from "../state/appActions";
import FullQuoteActions from "../state/fullQuoteActions";
import BravoApiClient from '../classes/BravoApiClient';
import ReactLoading from 'react-loading';


interface IState extends IQuoteStepState {
    quoteUid: string
}

export interface IProps extends RouteComponentProps {
    quoteUid: string,
    vehicles: Array<IVehicle>,
    fillQuote: (quoteUid: string) => Promise<any>,
    fillExternalQuote: (update: any) => Promise<any>,
    updateViolationList: (update: any) => Promise<any>,
    selectCoverageConfig: (coverageConfig: ICoverageConfig) => Promise<any>,
    quoteApiClient: IQuoteApiClient,
    lobApiClient: ILOBApiClient,
    PATHS: IPaths,
    stateCode: string | null;
}

class AgentLandingQuote extends React.Component<IProps, IState>
{
    componentDidMount() {
        this.setState({ updatingStore: true }, () => {
            this.props.fillQuote(this.props.quoteUid)
                .then((result) => {
                    const stateCode = result.data?.stateCode;
                    const client = new BravoApiClient(stateCode);
                    const rtrQuoteId = parseInt(result.data?.rtrQuoteId, 10);

                    // Portal violation catalog + coverage — do not block on external/Fiesta getQuote
                    // (that chain left D2C resume hanging; Driver then waited on violationList).
                    const loadViolations = client.getViolationList(stateCode)
                        .then((violResponse) => this.props.updateViolationList(violResponse.data))
                        .catch(() => { /* QuickDriver retries if needed */ });

                    const loadCoverage = this.props.quoteApiClient.getCoverageConfigs(this.props.quoteUid)
                        .then((covResponse) => {
                            if (covResponse.data && covResponse.data[0]) {
                                return this.props.selectCoverageConfig(covResponse.data[0]);
                            }
                        })
                        .catch(() => { });

                    const loadExternal = (rtrQuoteId > 0)
                        ? client.getQuote(rtrQuoteId)
                            .then((fqResponse) => {
                                fqResponse.data.rtrQuoteId = rtrQuoteId;
                                return this.props.fillExternalQuote({ quote: fqResponse.data });
                            })
                            .catch(() => { /* optional for quick-path resume */ })
                        : Promise.resolve();

                    return Promise.all([loadViolations, loadCoverage, loadExternal])
                        .then(() => {
                            this.props.history.push(this.props.PATHS.QUICK_VEHICLE);
                        });
                })
                .catch(() => {
                    this.setState({ updatingStore: false });
                });
        });
    }

    render() {
        return (
            <div>
                <Header />
                <div className="quote-step-body">
                    <div className="quote-step-container" style={{ maxWidth: "100em", width: "100%" }}>
                        <div className="card qContainer" style={{ padding: "2%" }}>
                            <div className="card-body">
                                <div className="titleArea"><h5>QUOTE LOADING...</h5></div>
                                <div className={"w-100 loading-indicator"}>
                                    <ReactLoading type={"spin"} color={"#0096AE"} height={'40px'} width={'40px'} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

let mapProps = (state: IAppState, ownProps: IQuoteStepComponentProps) => {
    var quoteUid = !ownProps.match.params["quoteUid"]
        ? null
        : ownProps.match.params["quoteUid"];

    return {
        quoteUid: quoteUid,
        vehicles: state.vehicles,
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);
    var fullQuoteActions = new FullQuoteActions(new BravoApiClient(''));

    return {
        fillQuote: (quoteUid) => dispatch(quoteActions.agentLandingQuote(quoteUid)),
        fillExternalQuote: (update) => dispatch(fullQuoteActions.fillExternalQuote(update.quote)),
        updateViolationList: (update: IViolationList) => dispatch(quoteActions.updateViolatioList(update)),
        selectCoverageConfig: (update: ICoverageConfig) => dispatch(quoteActions.selectCoverageConfig(update))
    };
};

export default connect(mapProps, mapDispatch)(AgentLandingQuote);
